// ============================================================
// audio/musicPhase5.js — (legacy) Phase 5 procedural music
// ============================================================
// Delegates to the single CHILL MUSIC track. Idempotent — never restarts.
import { startMusic } from './musicChill.js';

export function startPhase5Music() { startMusic(); }
export function stopPhase5Music()  { /* no-op — chill track stays playing */ }
